import dayjs from 'dayjs'

export interface StateType {
  title: string
  direction: string | number
  type: 'groups' | 'private'
  group: number[]
  children: { [groupId: number | string]: number[] }
  childrenPrivate: number[]
  date: string
  tasksIds: unknown[]

  addContent: boolean
  course: string | number
  typeDZ: string | number
  topic: string | number
  lesson: string | number

  isHomeworkDeferred: boolean
  dateAndTime: string
  autoCheckUniqueWork: boolean
  createUniqueWorkLink: boolean
}

const initState: StateType = {
  title: 'Уникальная работа',
  direction: '',
  type: 'groups',
  group: [],
  children: {},
  childrenPrivate: [],
  date: dayjs().format('YYYY-MM-DD'),
  tasksIds: [],

  addContent: false,
  course: '',
  typeDZ: 'topic',
  topic: '',
  lesson: '',

  isHomeworkDeferred: false,
  dateAndTime: '',
  autoCheckUniqueWork: false,
  createUniqueWorkLink: false,
}
export default initState;
